import React, {Fragment, useEffect, useRef} from 'react';
import Cart from './Cart';
import { translate } from '../Services/translation';
import { useSelector, useDispatch } from 'react-redux';
import { toggle } from '../Actions/Cart.action';

const QuickCart = () => {
    const dispatch = useDispatch();
    const { quantity, orderTotal, checkoutUrl, showInfo } = useSelector(
        (state) => state.cart
    );
    const onToggle = () => dispatch(toggle());
    const escapeRef = useRef();
    useEffect(() => {
        if (showInfo) {
            document.body.style.marginRight = `${window.innerWidth - document.body.offsetWidth}px`;
            document.body.style.overflow = 'hidden';
            escapeRef.current.focus();
        } else {
            document.body.style.marginRight = '';
            document.body.style.overflow = '';
        }
    }, [showInfo]);

    const closeOnTab = (e) => {
        if (e.keyCode === 9) {
            dispatch(toggle())
        }
    }

    const closeOnEsc = (e) => {
        if (e.keyCode === 27) {
            dispatch(toggle())
        }
    }

    return (
        <Fragment>
            <button
                className="cart__link--block"
                onClick={onToggle}
            >
                <img src="../../../ui/images/shopping-cart.svg" className="cart_icon" alt={translate('checkoutcart.icon')} />
                <span className="cart__quantity">{quantity}</span>
            </button>
            { showInfo &&
                <div 
                    className='cart__info-background'
                    onClick={onToggle}
                ></div>
            }
            <div onKeyDown={closeOnEsc} className={`cart__info ${!showInfo ? 'cart__info--hidden' : ''}`}>
                <h3 className="cart__title">
                    {translate('checkout.cart.title')}&nbsp;
                    {`(${quantity} ${translate('minicart.numberofproduct')})`}
                </h3>
                <button    
                    className="cart__close-button"
                    onClick={onToggle}
                    ref={escapeRef}
                ></button>
                { quantity > 0 &&
                    <Fragment>
                        <div className="cart-rows simple-table">
                            <Cart />
                        </div>
                        <div className="cart__summary">
                            <div className="cart__order-total">
                                <h3>{translate('checkout.cart.total')}</h3>
                                <h3>{orderTotal}</h3>
                            </div>
                            <a href={checkoutUrl} onKeyDown={closeOnTab} className="cart__checkout-button">
                                {translate('minicart.checkout')}
                            </a>
                        </div>
                    </Fragment>
                }
            </div>
        </Fragment>
    );
};

export default QuickCart;

